<template>
    <!--购买须知-->
    <div class="buyNotice introduction bgF9F9F9 roundBorder4" data-note="内容在管理中心的 内容-说明信息 菜单里编辑">
        <div class="title relative fWeight600">购买须知</div>
        <div class="padding16 lineH20r12 color999 font12r fWeight600" v-html="sourceType == 'key' ? content : source">
<!--            <p>1、课程性质：该课程为年付费系列课程，按课程计划定期更新。</p>-->
<!--            <p>2、提供回放：在有效期内，提供回放。</p>-->
<!--            <p>3、退款说明：该课程为虚拟内容服务，购买成功后不支持退换，敬请原谅。</p>-->
<!--            <p>4、版权保护：严禁录制与传播课程视频，违法必究。</p>-->
<!--            <p>5、更多帮助：在“我的”个人中心查看“联系师讯”，咨询师讯相关教务。</p>-->
        </div>
    </div>
    <!--购买须知END-->
</template>

<script>
import appHelper        from "@util/appHelper";
import requestManager   from "@comp/platformApi/requestManager";
import consoleApi       from "@comp/platformApi/consoleApi";

export default {
    name: "buyNotice",
    props : {
        // 说明信息字典的项目对应的 key 值
        source : String,

        // 源数据类型，key | content
        // key      按key加载数据
        // content  直接显示source的内容
        sourceType : {
            type : String,
            default: 'key'
        }
    },
    data() {
        return {
            content : ''
        }
    },
    methods : {
        loadContent(key) {
            const me = this;
            requestManager.request({
                url : 'portal/about/get_Agreement',
                data : {
                    code : key
                }
            }, (error, result) => {
                if (error)
                {
                    consoleApi.error('[buyNotice] load dynamic content [key: ' + key + '] failed.');
                    return;
                }

                if (result.errorCode)
                {
                    consoleApi.error('[buyNotice] ' + result.msg);
                    return;
                }

                me.content = result.data;
            });
        }
    },
    mounted() {
        if (this.source && this.sourceType == 'key')
        {
            this.loadContent(this.source);
        }
    },
    watch : {
        source() {
            if (this.source && this.sourceType == 'key')
            {
                this.loadContent(this.source);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.buyNotice {
    padding: 10px 0 18px;

    .title {
        position: relative;
        padding-left: 12px;

        &:before {
            display: block;
            content: '';
            position: absolute;
            width: 2px;
            height: 14px;
            background: #F55050;
            top: 5px;
            left: 0;
        }
    }
    p {
        margin-bottom: 12px;
    }
}
</style>
